import { FC, ReactElement } from 'react';

import { BottomSlider, MainWithFooterTemplate } from '@mopla/ui';
import SideOverlay from '@mopla/ui/organisms/SideOverlay/SideOverlay';
import { useBreakpoints } from '@mopla/utils';

interface IProps {
	open: boolean;
	onClose: VoidFunction;
	onBack?: VoidFunction;
	title: string;
	isConfirmationStep: boolean;
	content: ReactElement;
	footer: ReactElement;
}

export const DTicketSubscriptionWrapper: FC<IProps> = (props) => {
	const { open, onClose, onBack, title, isConfirmationStep, content, footer } =
		props;
	const { isAboveMobile } = useBreakpoints();

	const child = <MainWithFooterTemplate content={content} footer={footer} />;

	if (isAboveMobile) {
		return (
			<SideOverlay
				open={open}
				title={title}
				onOpen={() => undefined}
				onBack={onBack}
				onClose={onClose}
				widthPercentage={50}
			>
				{child}
			</SideOverlay>
		);
	}

	return (
		<BottomSlider
			open={open}
			onBack={!isConfirmationStep ? onBack : undefined}
			onClose={isConfirmationStep ? onClose : undefined}
			headerVariant="primary"
			headerSize="small"
			backgroundColor={isConfirmationStep ? 'primary.main' : 'neutral.40'}
			title={title}
		>
			{child}
		</BottomSlider>
	);
};
